import React, { Component } from 'react';
import axios from 'axios';

import './Login.css';
import Directory from '../Directory/Directory';
import HomePageEdit from '../Tools/HomePageEdit';
// import PdfUpload from '../Tools/PdfUpload';

export default class Login extends Component {
  state = {
    ui: '',
    pi: '',
    page: false,
    // page: true,
    err: false
  };

  componentDidMount() {
    axios('/api/logged-in').then(res => {
      this.setState({ page: true });
    });
  }

  getAdmin = () => {
    const { ui, pi } = this.state;
    
    axios
      .put('/api/admin', { user: ui, pass: pi })
      .then(res => {
        this.setState({ page: true });
      })
      .catch(() => {
        this.setState({ err: true });
      });
  };

  handleClick = () => {
    this.getAdmin();
  };

  handleKeyDown = e => {
    e.keyCode === 13 && this.getAdmin();
  };

  render() {
    const { page, err } = this.state;
    return (
      <div className="admin_login">
        <div className="component_img" />
        {!page && (
          <div className="login_top">
            <h1>Administrative Login</h1>
          <span>
          <img
                  src="https://cdn.onlinewebfonts.com/svg/img_283078.png"
                  alt="Username"
                />
            <input type="text" onChange={(e) => this.setState({ ui: e.target.value })} />
          </span>
          <span>
          <img
                src="https://image.flaticon.com/icons/svg/26/26053.svg"
                alt="lock"
              />
            <input
              type="password"
              onChange={(e) => this.setState({ pi: e.target.value })}
              onKeyDown={e => this.handleKeyDown(e)}
            />
          </span>
            <h3 onClick={this.handleClick}>Log In</h3>
            {err && (
              <p className="invalid">
                **Invalid credentials. Please try again.
              </p>
            )}
          </div>
        )}
        {page && (
          <div className="admin_content">
            <Directory />
            {/* <PdfUpload />
            <HomePageEdit /> */}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Login/Login.js